import { GetterTree, MutationTree } from 'vuex';
import { RootState } from '@/types/index';
import { ICampaignGroupsState, ICampaignGroup } from '@/types/campaign/groups';
import actions from '@/store/campaignGroupsAction';


const groupInit: ICampaignGroup = {
  id: '',
  name: '',
  comment: '',
  // TODO: Будет добавлено позже
  // startDate: '',
  // endDate: '',
  // timeZone: '',
  // budgetType: 'impressions',
  // amount: '',
  // goal: 0,
  // total: '',
  // daily: '',
  // spend: 0,
  // evenly: '',
  // asap: '',
  status: {
    label: 'Draft',
    value: 'draft'
  },
  errors: {
    name: []
  }
}

const state: ICampaignGroupsState = {
  group: null,
  groups: {
    data: [] as Array<ICampaignGroup>,
    paginationData: null
  },
  isSavingForm: false
}

const mutations: MutationTree<ICampaignGroupsState> = {
  setGroup(state, group) {
    state.group = group;
  },
  setGroups(state, groups) {
    if (!groups.paginationData || !groups.paginationData?.currentPage) {
      return;
    }
    state.groups.paginationData = groups.paginationData;
    state.groups.data = groups.data;
  },

  changeGroup(state, payload) {
    const { name, value } = payload;

    if (state?.group) {
      state.group[name] = value;
    }
  },
  changeIsSavingForm(state, value) {
    state.isSavingForm = value;
  },

  deleteGroup(state, groupId) {
    state.groups.data = state.groups.data.filter(group => group.id !== groupId);
  },
  clearGroup(state) {
    state.group = null;
  }
}

const getters: GetterTree<ICampaignGroupsState, RootState> = {
  getGroup(state) {
    return state.group;
  },
  getGroups(state) {
    return state.groups.data.map((g: ICampaignGroup) => g);
  },
  getGroupInit() {
    return groupInit;
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
